//src/api/platform/contexts/api.js

import axios from 'axios';
import API_BASE from '../../config';
import { getCsrfToken } from '../../../utils';
import { url } from './routes';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

/* ——— CSRF на каждый запрос ——— */
api.interceptors.request.use((cfg) => {
  cfg.headers['X-CSRF-TOKEN'] = getCsrfToken();
  return cfg;
});

/* ---------------- BOT ---------------- */
export const getBotStatus = (p, params) =>
  api.get(url('bot', 'status', p), { params });

export const startBot = (p, body) =>
  api.post(url('bot', 'start', p), body);

export const stopBot = (p, body) =>
  api.post(url('bot', 'stop', p), body);

/* ---------------- CHAT --------------- */
export const getChatStatus = (p, body) =>
  api.post(url('chat', 'status', p), body);

export const startChat = (p, body) =>
  api.post(url('chat', 'start', p), body);

export const stopChat = (p, body) =>
  api.post(url('chat', 'stop', p), body);

/* ------------- MESSAGE-LISTS --------- */
export const getMsgLists = (p, channelId) =>
  api.get(url('msgLists', 'list', p, channelId));

export const addMsgList = (p, channelId, body) =>
  api.post(url('msgLists', 'add', p, channelId), body);

export const deleteMsgList = (p, msgListId) =>
  api.delete(url('msgLists', 'del', p, msgListId));

/* ---------- QUICK-REPLIES ---------- */
export const getQuickReplies  = (p, ch)          =>
  api.get (url('quick','list', p),          { params:{ channel_id: ch } });

export const addQuickReply    = (p, body)        =>
  api.post(url('quick','add',  p), body);

export const updateQuickReply = (p, id, body)    =>
  api.put (url('quick','item', p, id),      body);

export const deleteQuickReply = (p, id)          =>
  api.delete(url('quick','item',p, id));

export const setQuickOrder    = (p, body)        =>
  api.put (url('quick','order',p),           body);

export const quickSendMessage = (p, body)        =>
  api.post(url('quick','send', p),           body);

/* ---------- STREAM-INFO (Kick/WTV) --- */
export const getStreamInfo    = (p, channel, group_id) =>
  api.get(url('stream','info', p),    { params:{ channel, group_id } });

export const parsePlayer      = (p, body) =>
  api.post(url('stream', 'parse', p), body);

/* ---------- CHANNEL-SETUP ------------ */
export const getChannelId     = (p, name)  =>
  api.post(url('channel','id',  p),   { channel_name:name });

export const getAccounts      = (p, grp)  =>
  api.get (url('channel','accs',p),   { params:{ group_id:grp } });